import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import ReactDOM from "react-dom";
import { addUserSpecificParams } from "../../services/utils";

import HelpIconButtonWithTooltip from "../ui-building-blocks/icons/HelpIconButtonWithTooltip";

const IFRAME_REF = "typeform-iframe";
const SHARE_DOC_LINK =
  "https://docs.google.com/a/marketgames.io/document/d/1n48v17MARTi5nXgGYUga1RJzD19iWzp-WvIUuAaSLFo/edit?usp=sharing";

class HelpIconButtonWithTooltipAndTypeformModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldShowTypeformModal: false
    };
  }

  showTypeformModal = (e) => {
    e.preventDefault();
    this.setState({
      shouldShowTypeformModal: true
    });
  };

  hideTypeformModal = () => {
    this.setState({ shouldShowTypeformModal: false });
  };

  onModalEntered = () => {
    // Focus the iframe after the modal transitions in
    ReactDOM.findDOMNode(this.refs[IFRAME_REF]).focus();
  };

  getTooltipContent() {
    const { learnMoreAbout, mgAbout, mgSection } = this.props;

    const learnMoreButton = (
      <a className="pointer" href="/#" onClick={this.showTypeformModal}>
        Learn More
      </a>
    );

    const learnMoreContent = (
      <span>
        To learn more about {learnMoreAbout}, please click on {learnMoreButton}
      </span>
    );

    const mgBusinessCaseButton = (
      <a className="pointer" href={SHARE_DOC_LINK} target="_blank" rel="noreferrer">
        MG Business Case
      </a>
    );

    const mgContent = (
      <span>
        To learn more about {mgAbout}, please read the {mgSection} section of
        the {mgBusinessCaseButton}.
      </span>
    );

    return (
      <span>
        {this.props.description}
        {learnMoreAbout && learnMoreContent}
        {mgAbout && mgSection && mgContent}
      </span>
    );
  }

  get category() {
    const { learnMoreAbout, mgAbout, mgSection } = this.props;

    if (learnMoreAbout) {
      return learnMoreAbout;
    }

    if (mgSection && mgAbout) {
      return `${mgSection} - ${mgAbout}`;
    }

    return null;
  }

  render() {
    return (
      <span>
        <HelpIconButtonWithTooltip
          category={this.category}
          tooltipContent={this.getTooltipContent()}
          iconSize={this.props.iconSize}
        />
        {this.props.typeformUrl && (
          <Modal
            backdrop
            dialogClassName="typeform-modal"
            show={this.state.shouldShowTypeformModal}
            onEntered={this.onModalEntered}
            onHide={this.hideTypeformModal}
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <iframe
                ref={IFRAME_REF}
                src={addUserSpecificParams(this.props.typeformUrl)}
                style={{ width: "100%", height: "500px" }}
                title="Typeform"
              />
            </Modal.Body>
          </Modal>
        )}
      </span>
    );
  }
}

HelpIconButtonWithTooltipAndTypeformModal.propTypes = {
  description: PropTypes.string.isRequired,
  iconSize: PropTypes.oneOf(["xs", "sm"])
};

export default HelpIconButtonWithTooltipAndTypeformModal;



// WEBPACK FOOTER //
// ./src/components/typeform/HelpIconButtonWithTooltipAndTypeformModal.js